<template>
  <v-combobox
    v-model="modelVal"
    :items="itemList"
    :loading="loading"
    :readonly="tableLoading"
    :search-input.sync="searchingAction"
    item-text="value"
    :item-value="itemValueKey"
    placeholder="ค้นหาจากรหัสงาน/ ชื่องาน / ชื่อผู้ขับ / ป้ายทะเบียนรถ"
    prepend-inner-icon="mdi-magnify"
    append-icon=""
    :clearable="tableLoading === false"
    return-object
    filled
    dense
    hide-no-data
    hide-selected
    hide-details
    flat
    height="44"
    outlined
    class="app-custom-input"
    @change="itemChange"
    :disabled="disabled"
  ></v-combobox>
</template>
<script>
import _ from "lodash";
import { getJobBySeachingService } from "@/services/api/jobs";
import { appDecodeSingleURIComponentHelper } from "@/services/appStringHelpper";

export default {
  name: "JobSearchingInput",
  props: {
    itemValueKey: {
      default: "key",
      type: String,
    },
    enableEnterSearch: {
      default: true,
      type: Boolean,
    },
    tableLoading: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    this.getParamQuery();
  },
  data: () => ({
    modelVal: null,
    itemList: [],
    loading: false,
    searchingAction: null,
    currentSearchText: "",
    searchCountTimer: undefined,
    queryOrder: {
      fieldid: "fieldId",
      text: "text",
    },
    formData: {
      fieldId: null,
      text: null,
    },
    firstInit: false,
    selectFromListChecker: false,
  }),
  watch: {
    searchingAction(val) {
      if (!_.isNil(val) && this.firstInit && !this.selectFromListChecker) {
        this.currentSearchText = val;
        if (val.length > 2) {
          clearTimeout(this.searchCountTimer);
          this.loading = true;
          this.searchCountTimer = setTimeout(() => {
            this.callApi(val); // call api function
          }, 1500);
        }
      }
      this.firstInit = true;
      this.selectFromListChecker = false;
    },
  },
  methods: {
    getParamQuery() {
      Object.keys(this.queryOrder).forEach((key) => {
        if (!_.isNil(this.$route.query[key])) {
          switch (key) {
            case "text":
              this.formData[this.queryOrder[key]] =
                appDecodeSingleURIComponentHelper(this.$route.query[key]);
              break;
            default:
              this.formData[this.queryOrder[key]] = this.$route.query[key];
          }
        }
      });

      if (!_.isNil(this.formData["text"])) {
        this.modelVal = this.formData["text"];
      }
    },
    async callApi(val) {
      let responseData = await getJobBySeachingService(this.$store, val);
      if (responseData["code"] === 200) {
        this.itemList = responseData["data"];
      } else {
        this.itemList = [];
      }
      this.loading = false;
    },
    itemChange() {
      if (
        _.isString(this.modelVal) === false &&
        _.isNil(this.modelVal) === false
      ) {
        this.selectFromListChecker = true;
        this.$emit("searchItemChange", this.modelVal);
        this.modelVal = this.modelVal["value"];
        this.itemList = [];
      } else if (_.isString(this.modelVal) === true) {
        this.selectFromListChecker = false;
        clearTimeout(this.searchCountTimer);
        this.loading = false;

        this.$emit("searchItemChange", {
          value: this.currentSearchText,
        });
        this.itemList = [];
      } else {
        // console.log("modelVal", this.modelVal, this.currentSearchText);
        this.selectFromListChecker = false;
        clearTimeout(this.searchCountTimer);
        this.loading = false;

        this.$emit("searchItemChange", {
          value: null,
        });
        this.itemList = [];
      }

      clearTimeout(this.searchCountTimer);
      this.loading = false;
    },
  },
};
</script>
